import { Injectable } from '@angular/core'
import _ from 'lodash'

@Injectable({
    providedIn: 'root',
})
export class GeneralMapRandomParamService {

    public addRandomParamToWmsLayerWithFilter(config: any): any {
        this.addRandomParamToWmsLayerWithFilterRecursive(config)
    }

    public getMapRandom(): any {
        return localStorage.getItem('map-random')
    }

    public removeRandomParamFromWmsLayerWithFilter(config: any): any {
        this.removeRandomParamFromWmsLayerWithFilterRecursive(config)
    }

    public setMapRandom(mapRandom: any): void {
        localStorage.setItem('map-random', mapRandom)
    }

    /*************************************************************************/

    private addRandomParamToWmsLayerWithFilterRecursive(config: any): any {
        if (config && config.layers && _.isArray(config.layers)) {
            _.forEach(config.layers, value => {
                this.addRandomParamToWmsLayerWithFilterRecursive(value)
            })
        } else if (config.layer && config.layer.type && config.layer.type === 'wms') {
            if (config.id && config.layer.wms && config.layer.reload === true) {
                config.layer.wms.random = new Date().getTime()
            }
        }

        return config
    }

    private removeRandomParamFromWmsLayerWithFilterRecursive(config: any): any {
        if (config && config.layers && _.isArray(config.layers)) {
            _.forEach(config.layers, value => {
                this.removeRandomParamFromWmsLayerWithFilterRecursive(value)
            })
        } else if (config.layer && config.layer.type && config.layer.type === 'wms') {
            if (config.id && config.layer.wms && config.layer.reload === true) {
                delete config.layer.wms.random
            }
        }

        return config
    }
}
